module.exports = __webpack_public_path__ + "static/media/youtube.644201aa.svg";